import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import CaseStudyPage from './pages/CaseStudyPage';
import Layout from './components/Layout';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Layout data-id="element-3">
              <HomePage data-id="element-4" />
            </Layout>} data-id="element-2" />
        <Route path="/about" element={<Layout data-id="element-6">
              <AboutPage data-id="element-7" />
            </Layout>} data-id="element-5" />
        <Route path="/contact" element={<Layout data-id="element-9">
              <ContactPage data-id="element-10" />
            </Layout>} data-id="element-8" />
        <Route path="/case-study/:id" element={<Layout data-id="element-12">
              <CaseStudyPage data-id="element-13" />
            </Layout>} data-id="element-11" />
      </Routes>
    </BrowserRouter>;
}